import { useEffect, useState } from "react"

import api from "@/lib/api"
import { Section } from "@/components/page"
import { CourseCard, type CourseCardCourse } from "@/components/academy/CourseCard"

interface SeedbedAccess {
  courses?: CourseCardCourse[]
}

// "Descubre más" en Inicio: cursos que el estudiante aún no tiene. Con sesión no hay
// catálogo aparte, así que aquí vive el descubrimiento. Primero lo que su semillero le
// habilitó; si no tiene, el catálogo público. Si nada carga, la sección no aparece.
export function DiscoverMore({ excludeIds }: { excludeIds: string[] }) {
  const [courses, setCourses] = useState<CourseCardCourse[]>([])

  useEffect(() => {
    let cancelled = false

    const loadCatalog = () =>
      api
        .get("/academy/courses?page=1&limit=24")
        .then(({ data }) => {
          if (!cancelled) setCourses((data.data?.courses ?? []) as CourseCardCourse[])
        })
        .catch(() => {})

    api
      .get("/academy/seedbeds/me")
      .then(({ data }) => {
        const mine = (data.data as SeedbedAccess).courses ?? []
        if (mine.length === 0) return loadCatalog()
        if (!cancelled) setCourses(mine)
      })
      .catch(() => loadCatalog())

    return () => {
      cancelled = true
    }
  }, [])

  const items = courses.filter((c) => !excludeIds.includes(c.id)).slice(0, 8)
  if (items.length === 0) return null

  return (
    <Section titleId="descubre-mas" title="Descubre más">
      <div className="grid gap-x-5 gap-y-8 grid-cols-[repeat(auto-fit,minmax(17rem,1fr))] [&>*]:max-w-[40rem]">
        {items.map((course, i) => (
          // En móvil solo los cuatro primeros: más portadas apiladas son un scroll eterno.
          <div key={course.id} className={i >= 4 ? "hidden sm:block" : undefined}>
            <CourseCard course={course} />
          </div>
        ))}
      </div>
    </Section>
  )
}
